// extracted by mini-css-extract-plugin
export var badge = "_h7-2";
export var detailsPanel = "_h7-0";
export var resultRow = "_h7-1";